let backendHost, bfHost, b2Host, frontendHost;

const hostname = window && window.location && window.location.hostname;

if (hostname.includes('sistema-staging')) {
  backendHost = "https://api-staging.imtbike.com";
  frontendHost = "https://staging.imtbike.com";
  bfHost = "https://secure-staging.imtbike.com";
  b2Host = "https://agency-staging.imtbike.com";
} else if (hostname.includes('sistema.imtbike')) {
  backendHost = "https://api.imtbike.com";
  frontendHost = "https://sistema.imtbike.com";
  bfHost = "https://secure.imtbike.com";
  b2Host = "https://agency.imtbike.com";
} else {
  backendHost = process.env.REACT_APP_BACKEND_HOST || "http://localhost:3000";
  frontendHost = "http://localhost:3001";
  bfHost = "http://localhost:3002";
  b2Host = "http://localhost:3003";
}

export const API_ROOT = `${backendHost}`;
export const FRONTEND_ROOT = `${frontendHost}`;
export const BF_ROOT = `${bfHost}`;
export const B2_ROOT = `${b2Host}`;



// WEBPACK FOOTER //
// ./src/api-config.js